import { useState } from "react";
import { faqs } from "@/mocks/chiagua";

export default function Faq() {
  const [openId, setOpenId] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <div className="text-center">
        <p className="font-heading text-2xl text-primary-500 md:text-3xl">🙋 常见问题</p>
        <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">围观之前，先看这里</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          关于神评论、梗图素材、投稿与更新频率，你最关心的几个问题都替你整理好了。
        </p>
      </div>

      <div className="mt-8 space-y-3">
        {faqs.map((f, i) => {
          const open = openId === i;
          return (
            <div
              key={i}
              className={`overflow-hidden rounded-2xl border transition-colors ${
                open ? "border-background-300 bg-background-50" : "border-background-200 bg-background-100"
              }`}
            >
              <button
                type="button"
                onClick={() => setOpenId(open ? null : i)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
              >
                <span className="flex items-center gap-3 text-base font-bold text-foreground-900">
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-black ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-300 text-foreground-700"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </span>
                <i
                  className={`shrink-0 text-lg text-foreground-500 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
                  aria-hidden="true"
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-700 md:px-6 md:pl-16">
                    {f.a}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}